import { z } from 'zod';

export const createCommentSchema = z.object({
  text: z.string().trim().min(1, 'Comment text is required').max(3000),
});

export type CreateCommentInput = z.infer<typeof createCommentSchema>;

export const updateCommentSchema = createCommentSchema;
export type UpdateCommentInput = z.infer<typeof updateCommentSchema>;
